import {
  HiBuildingStorefront,
  HiChartPie,
  HiCurrencyDollar,
  HiGift,
  HiInboxArrowDown,
  HiKey,
  HiLink,
  HiMiniDocumentText,
  HiMiniUserCircle,
  HiUsers,
} from "react-icons/hi2";
import { FaBarcode, FaPeopleCarryBox, FaFileInvoice, FaFileInvoiceDollar, FaHandHoldingDollar, FaMoneyBillTransfer } from "react-icons/fa6";
import {
  ACCOUNT_ROUTE,
  BILLING_ROUTE,
  COMMISSIONS_ROUTE,
  MI_PERFIL_ROUTE,
  LOUNGES_ROUTE,
  MARKETING_ROUTE,
  PRODUCTS_ROUTE,
  REPORTS_ROUTE,
  SECURITY_ROUTE,
  SERVICES_ROUTE,
  SUPPLIERS_ROUTE,
  ACCOUNTS_PAYABLE_ROUTE,
  RECEIVABLES_ROUTE,
  EXCHANGE_RATE_ROUTE,
  PURCHASE_ORDERS_ROUTE,
  INTERNAL_ORDERS_ROUTE,
  TEAM_ROUTE,
  ANALYTICS_ROUTE,
  INTEGRATIONS_ROUTE,
  LOYALTY_ROUTE,
} from "../../models/localPath";
// @ts-ignore
import { Icon, IconWrapper } from "@viuti/recursos";
import { MarketingIcon, ServiceConfigIcon } from "@Models/icons";
import { v4 as uuid } from "uuid";

// UUIDs de modulosv2 (toggles individuales), NO de tipomodulos (categorías).
// Deben coincidir con los que usa App.tsx en ModuleRoute.
//
// Candados (utilities/menuLocks.ts): `addon` / `planFeature` marcan ítems
// contratables — se muestran SIEMPRE (con candado si falta) y la ruta de
// destino presenta la pantalla vendedora. `planFeature` debe coincidir con el
// <PlanGate feature> de la ruta en App.tsx. Explorador NO lleva candado: el
// explorador es libre por plan (lo contratable es su asistente IA, que se
// gestiona dentro del módulo).

// 038/095 Fidelización (Prikly Pass): add-on por sede. Se oculta SOLO si el
// kill-switch LOYALTY_ENABLED está apagado (módulo no desplegado).
const LOYALTY_ITEM = () => ({
  id: uuid(),
  icon: <IconWrapper icon={HiGift} size={16} />,
  name: "Fidelización",
  redirectTo: LOYALTY_ROUTE,
  accessId: "f414e1d8-ca35-466d-bbd3-0cc53c6a7504",
  addon: "fidelizacion" as const,
});
export const COMMON_NAVIGATION_OPTIONS = [
  {
    id: uuid(),
    label: "Gestionar mi negocio",
    items: [
      {
        id: uuid(),
        icon: <IconWrapper icon={HiUsers} size={16} />,
        name: "Mi equipo",
        redirectTo: TEAM_ROUTE,
        accessId: "b05792dd-c9f7-4924-92d8-3d53bea8192a",
      },
      {
        id: uuid(),
        icon: <Icon size={16} color={"#392B75"} path={ServiceConfigIcon} />,
        name: "Servicios",
        redirectTo: SERVICES_ROUTE,
        accessId: "49400f7e-3bf1-4f6d-8f67-ea58c55f5757",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={FaBarcode} size={16} />,
        name: "Productos",
        redirectTo: PRODUCTS_ROUTE,
        accessId: "28fc22bf-3df8-4f7c-bfe8-f9082faf12b5",
      },
      {
        id: uuid(),
        icon: <Icon size={16} color={"#392B75"} path={MarketingIcon} />,
        name: "Marketing",
        redirectTo: MARKETING_ROUTE,
        accessId: "f21678af-cdd9-4aa6-ae21-196ac82f84e6",
        planFeature: "marketing",
      },
      LOYALTY_ITEM(),
      {
        id: uuid(),
        icon: <IconWrapper icon={HiCurrencyDollar} size={16} />,
        name: "Comisiones",
        redirectTo: COMMISSIONS_ROUTE,
        accessId: "90df4809-683d-479e-803e-eb01d4b26512",
        planFeature: "comisiones",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={FaPeopleCarryBox} size={16} />,
        name: "Proveedores",
        redirectTo: SUPPLIERS_ROUTE,
        accessId: "b7cb89ff-ef98-4465-8ecc-4fb27bff7ac9",
        planFeature: "compras",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={FaFileInvoiceDollar} size={16} />,
        name: "Cuentas por Pagar",
        redirectTo: ACCOUNTS_PAYABLE_ROUTE,
        accessId: "8cf0bb98-8c95-462f-8461-deb99943504b",
        planFeature: "compras",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={FaHandHoldingDollar} size={16} />,
        name: "Cuentas por Cobrar",
        redirectTo: RECEIVABLES_ROUTE,
        accessId: "e8a1b2c3-cxc0-4a00-b000-000000000010",
        planFeature: "cuentas_por_cobrar",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={FaMoneyBillTransfer} size={16} />,
        name: "Tipo de Cambio",
        redirectTo: EXCHANGE_RATE_ROUTE,
        accessId: "e8a1b2c3-tc00-4a00-b000-000000000010",
        planFeature: "tipo_cambio",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={FaFileInvoice} size={16} />,
        name: "Órdenes de compra",
        redirectTo: PURCHASE_ORDERS_ROUTE,
        accessId: "912e4737-19f7-43f4-9a50-edfc5b376330",
        planFeature: "compras",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={FaPeopleCarryBox} size={16} />,
        name: "Pedidos internos",
        redirectTo: INTERNAL_ORDERS_ROUTE,
        accessId: "ac5424b0-d272-45cc-b0fd-e92febd779d5",
        planFeature: "pedidos_internos",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={HiBuildingStorefront} size={16} />,
        name: "Locales",
        redirectTo: LOUNGES_ROUTE,
        accessId: "ba959108-c4ae-4167-9092-ee177883ca82",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={HiInboxArrowDown} size={16} />,
        name: "Reportes",
        redirectTo: REPORTS_ROUTE,
        accessId: "b67aa607-51b0-4e22-a070-ef38d48c2045",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={HiChartPie} size={16} />,
        name: "Explorador",
        redirectTo: ANALYTICS_ROUTE,
        accessId: "5d6ff83a-9bb0-4e98-bdc6-59b44b891b09",
      },
    ],
  },
  {
    id: uuid(),
    label: "Configuración",
    items: [
      {
        id: uuid(),
        icon: <IconWrapper icon={HiMiniUserCircle} size={16} />,
        name: "Mi perfil",
        redirectTo: MI_PERFIL_ROUTE,
        accessId: "",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={HiMiniUserCircle} size={16} />,
        name: "Mi cuenta",
        redirectTo: ACCOUNT_ROUTE,
        accessId: "c22153e1-efcb-461d-babe-0418ce5642bb",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={HiMiniDocumentText} size={16} />,
        name: "Facturación electrónica",
        redirectTo: BILLING_ROUTE,
        accessId: "389c7a51-8873-4c4d-85d9-d6bb2e1cb1f8",
      },
    ],
  },
];

export const ADMIN_NAVIGATION_OPTIONS = [
  {
    id: uuid(),
    label: "Gestionar mi negocio",
    items: [
      {
        id: uuid(),
        icon: <IconWrapper icon={HiUsers} size={16} />,
        name: "Mi equipo",
        redirectTo: TEAM_ROUTE,
        accessId: "b05792dd-c9f7-4924-92d8-3d53bea8192a",
      },
      {
        id: uuid(),
        icon: <Icon size={16} color={"#392B75"} path={ServiceConfigIcon} />,
        name: "Servicios",
        redirectTo: SERVICES_ROUTE,
        accessId: "49400f7e-3bf1-4f6d-8f67-ea58c55f5757",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={FaBarcode} size={16} />,
        name: "Productos",
        redirectTo: PRODUCTS_ROUTE,
        accessId: "28fc22bf-3df8-4f7c-bfe8-f9082faf12b5",
      },
      {
        id: uuid(),
        icon: <Icon size={16} color={"#392B75"} path={MarketingIcon} />,
        name: "Marketing",
        redirectTo: MARKETING_ROUTE,
        accessId: "f21678af-cdd9-4aa6-ae21-196ac82f84e6",
        planFeature: "marketing",
      },
      LOYALTY_ITEM(),
      {
        id: uuid(),
        icon: <IconWrapper icon={HiCurrencyDollar} size={16} />,
        name: "Comisiones",
        redirectTo: COMMISSIONS_ROUTE,
        accessId: "90df4809-683d-479e-803e-eb01d4b26512",
        planFeature: "comisiones",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={HiBuildingStorefront} size={16} />,
        name: "Locales",
        redirectTo: LOUNGES_ROUTE,
        accessId: "ba959108-c4ae-4167-9092-ee177883ca82",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={HiInboxArrowDown} size={16} />,
        name: "Reportes",
        redirectTo: REPORTS_ROUTE,
        accessId: "b67aa607-51b0-4e22-a070-ef38d48c2045",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={HiChartPie} size={16} />,
        name: "Explorador",
        redirectTo: ANALYTICS_ROUTE,
        accessId: "5d6ff83a-9bb0-4e98-bdc6-59b44b891b09",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={FaPeopleCarryBox} size={16} />,
        name: "Proveedores",
        redirectTo: SUPPLIERS_ROUTE,
        accessId: "b7cb89ff-ef98-4465-8ecc-4fb27bff7ac9",
        planFeature: "compras",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={FaFileInvoiceDollar} size={16} />,
        name: "Cuentas por Pagar",
        redirectTo: ACCOUNTS_PAYABLE_ROUTE,
        accessId: "8cf0bb98-8c95-462f-8461-deb99943504b",
        planFeature: "compras",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={FaHandHoldingDollar} size={16} />,
        name: "Cuentas por Cobrar",
        redirectTo: RECEIVABLES_ROUTE,
        accessId: "e8a1b2c3-cxc0-4a00-b000-000000000010",
        planFeature: "cuentas_por_cobrar",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={FaMoneyBillTransfer} size={16} />,
        name: "Tipo de Cambio",
        redirectTo: EXCHANGE_RATE_ROUTE,
        accessId: "e8a1b2c3-tc00-4a00-b000-000000000010",
        planFeature: "tipo_cambio",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={FaFileInvoice} size={16} />,
        name: "Órdenes de compra",
        redirectTo: PURCHASE_ORDERS_ROUTE,
        accessId: "912e4737-19f7-43f4-9a50-edfc5b376330",
        planFeature: "compras",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={FaPeopleCarryBox} size={16} />,
        name: "Pedidos internos",
        redirectTo: INTERNAL_ORDERS_ROUTE,
        accessId: "ac5424b0-d272-45cc-b0fd-e92febd779d5",
        planFeature: "pedidos_internos",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={HiLink} size={16} />,
        name: "Integraciones",
        redirectTo: INTEGRATIONS_ROUTE,
        accessId: "c5d6e7f8-9a0b-4c1d-2e3f-4a5b6c7d8e9f",
        planFeature: "integraciones",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={HiKey} size={16} />,
        name: "Permisos",
        redirectTo: SECURITY_ROUTE,
        accessId: "",
      },
    ],
  },
  {
    id: uuid(),
    label: "Configuración",
    items: [
      {
        id: uuid(),
        icon: <IconWrapper icon={HiMiniUserCircle} size={16} />,
        name: "Mi perfil",
        redirectTo: MI_PERFIL_ROUTE,
        accessId: "",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={HiMiniUserCircle} size={16} />,
        name: "Mi cuenta",
        redirectTo: ACCOUNT_ROUTE,
        accessId: "c22153e1-efcb-461d-babe-0418ce5642bb",
      },
      {
        id: uuid(),
        icon: <IconWrapper icon={HiMiniDocumentText} size={16} />,
        name: "Facturación electrónica",
        redirectTo: BILLING_ROUTE,
        accessId: "389c7a51-8873-4c4d-85d9-d6bb2e1cb1f8",
      },
    ],
  },
];
